/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedPersonNameDTO } from './ReferencedPersonNameDTO';
import {
    ReferencedPersonNameDTOFromJSON,
    ReferencedPersonNameDTOFromJSONTyped,
    ReferencedPersonNameDTOToJSON,
    ReferencedPersonNameDTOToJSONTyped,
} from './ReferencedPersonNameDTO';

/**
 * 
 * @export
 * @interface ProjectToPersonDTO
 */
export interface ProjectToPersonDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectToPersonDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectToPersonDTO
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectToPersonDTO
     */
    sequence?: number;
    /**
     * 
     * @type {ReferencedPersonNameDTO}
     * @memberof ProjectToPersonDTO
     */
    personName?: ReferencedPersonNameDTO;
}

/**
 * Check if a given object implements the ProjectToPersonDTO interface.
 */
export function instanceOfProjectToPersonDTO(value: object): value is ProjectToPersonDTO {
    return true;
}

export function ProjectToPersonDTOFromJSON(json: any): ProjectToPersonDTO {
    return ProjectToPersonDTOFromJSONTyped(json, false);
}

export function ProjectToPersonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectToPersonDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'role': json['role'] == null ? undefined : json['role'],
                  'sequence': json['sequence'] == null ? undefined : json['sequence'],
                  'personName': json['personName'] == null ? undefined : ReferencedPersonNameDTOFromJSON(json['personName']),
    };
}

export function ProjectToPersonDTOToJSON(json: any): ProjectToPersonDTO {
    return ProjectToPersonDTOToJSONTyped(json, false);
}

export function ProjectToPersonDTOToJSONTyped(value?: ProjectToPersonDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'role': value['role'],
        'sequence': value['sequence'],
        'personName': ReferencedPersonNameDTOToJSON(value['personName']),
    };
}


